import { NotFound } from 'components/common/NotFound';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import DeliveryPage from './pages/DeliveryPage';

export default function DeliveryFeature() {
  const { path } = useRouteMatch();

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <Redirect to={`${path}/delivery-setting`} />
        </Route>
        <Route exact path={`${path}/delivery-setting`}>
          <DeliveryPage />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </div>
  );
}
